import { getAccountImportExportSettingFormConfig } from './getAccountImportExportSettingFormConfig';
export const getAccountExportSettingFormConfig = (defaultAccountFieldTypeValues, settingSourceFieldExclusions) => {
    const sourceConfig = {
        type: 'form.text',
        key: 'source',
        label: 'Source',
        hidden: {
            when: '^^/type',
            dataIn: settingSourceFieldExclusions !== null && settingSourceFieldExclusions !== void 0 ? settingSourceFieldExclusions : [],
        },
    };
    return getAccountImportExportSettingFormConfig(defaultAccountFieldTypeValues, [sourceConfig]);
};
